import React from 'react'
import {alert, renderPhoneNumber} from '../../../../../utils/helper'
import {useMutation} from '@apollo/client'
import {SEND_SMS_TPV} from '../../../../../utils/GraphQLAPI'
export default function TPVStatus({formik}: any) {
  const [sendSMSTPV] = useMutation(SEND_SMS_TPV, {
    onCompleted: () => alert('SMS sent successfully', 'success'),
  })
  return (
    <div className='' data-kt-stepper-element='content'>
      <div className='w-100 min-h-450px px-lg-5'>
        <h4 className='text-gray-800 fs-2 fw-bolder mb-7'>TPV Details</h4>
        <div className='d-flex justify-content-between mb-3'>
          <h6 className='text-gray-700 fs-6'>Customer Name</h6>
          <p className='text-gray-600 fs-6'>{`${formik.values.customerFirstName} ${formik.values.customerLastName}`}</p>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <h6 className='text-gray-700 fs-6'>Customer Primary Phone Number</h6>
          <p className='text-gray-600 fs-6'>
            {Boolean(formik.values.customerPrimaryPhoneNumber)
              ? renderPhoneNumber(formik.values.customerPrimaryPhoneNumber)
              : '-'}
          </p>
        </div>

        {formik.values.tpvType !== 'SMS TPV' && formik.values.tpvStatus !== 'UNVERIFIED' && (
          <div className='d-flex justify-content-between mb-3'>
            <h6 className='text-gray-700 fs-6'>Customer Transfer Phone Number</h6>
            <p className='text-gray-600 fs-6'>
              {Boolean(formik.values.transferPhoneNumber)
                ? renderPhoneNumber(formik.values.transferPhoneNumber)
                : '-'}
            </p>
          </div>
        )}
        {formik.values.tpvStatus !== 'UNVERIFIED' && formik.values.tpvType !== 'SMS TPV' && (
          
          <div className='d-flex justify-content-between mb-3'>
              <h6 className='text-gray-700 fs-6'>Pincode</h6>
              <p className='text-gray-600 fs-6'>{formik.values.pincode}</p>
            </div>
        )}
        {formik.values.tpvType === 'SMS TPV' &&  formik.values.tpvStatus==="PENDING"&&(
          <button
            className='btn btn-primary'
            onClick={(e) => {
              e.stopPropagation()
              sendSMSTPV({
                variables: {
                  tpvId: formik.values?.tpvId,
                },
              })
            }}
          >
            Resend SMS TPV
          </button>
        )}

       
      

        {/* {
          formik.values.tpvStatus === "UNVERIFIED" &&(
            <button className='btn btn-primary'>Resend Contract</button>
          )
        } */}
      </div>
    </div>
  )
}
